export default "__VITE_ASSET__19901e2d__"